import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "col-12 row px-3 py-2" }
const _hoisted_2 = { class: "col-12 col-md-4 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Pre-Screening")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "form-group col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "tb-test" }, " TB Test ", -1 /* HOISTED */)
const _hoisted_6 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "tbTestTrue"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_8 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "tbTestFalse"
}, " No ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "lead-screening" }, " Lead Screening ", -1 /* HOISTED */)
const _hoisted_12 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "leadScreeningTrue"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_14 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "leadScreeningFalse"
}, " No ", -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group w-90 col-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "pediatric-other" }, " Other ", -1 /* HOISTED */)
const _hoisted_18 = { class: "col-md-8 g-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Newborn History")
], -1 /* HOISTED */)
const _hoisted_20 = { class: "col-12 row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-check custom-checkbox form-check-inline me-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "newborn-history-na"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "N/A")
], -1 /* HOISTED */)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "gestational-age" }, " Gestational Age at Birth ", -1 /* HOISTED */)
const _hoisted_27 = { class: "ps-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", { class: "py-1" }, "Length", -1 /* HOISTED */)
const _hoisted_29 = { class: "d-flex row align-items-end" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "lengthScale",
  class: "mb-0 mt-1"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Scale")
], -1 /* HOISTED */)
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "fontanels" }, " Fontanels ", -1 /* HOISTED */)
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = { class: "form-check custom-checkbox form-check-inline me-3" }
const _hoisted_38 = ["id", "value"]
const _hoisted_39 = ["for"]
const _hoisted_40 = { class: "me-1" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "umbilicus" }, " Umbilicus ", -1 /* HOISTED */)
const _hoisted_43 = { class: "row ps-3 col-12" }
const _hoisted_44 = { class: "form-check custom-checkbox form-check-inline col-md-5" }
const _hoisted_45 = ["id", "value"]
const _hoisted_46 = ["for"]
const _hoisted_47 = { class: "me-1" }
const _hoisted_48 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "newborn-screening-results" }, " Newborn Screening Results ", -1 /* HOISTED */)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "birth-weight" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "py-1" }, "Birth Weight")
], -1 /* HOISTED */)
const _hoisted_52 = {
  class: "form-group row ps-0",
  id: "birth-weight"
}
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  for: "birthWeightScale",
  class: "mb-0"
}, " Scale ", -1 /* HOISTED */)
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = {
  for: "birth-weight-lb",
  class: "mb-0"
}
const _hoisted_57 = ["placeholder"]
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  for: "birth-weight-oz",
  class: "mb-0"
}, " Birth Weight oz. ", -1 /* HOISTED */)
const _hoisted_60 = { class: "ps-0" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("strong", { class: "py-1" }, "Head Circumference", -1 /* HOISTED */)
const _hoisted_62 = { class: "d-flex row align-items-end" }
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", {
  for: "headCircumferenceScale",
  class: "mb-0 mt-1"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Scale")
], -1 /* HOISTED */)
const _hoisted_65 = { class: "col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnumTypeaheadInput = _resolveComponent("EnumTypeaheadInput")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "tbTestTrue",
            name: "hasTBTest",
            class: "form-check-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.tbTest) = $event)),
            value: true
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, _ctx.patientHealthHistory.pediatricHistory.tbTest]
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "tbTestFalse",
            name: "hasTBTest",
            class: "form-check-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.tbTest) = $event)),
            value: false
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, _ctx.patientHealthHistory.pediatricHistory.tbTest]
          ]),
          _hoisted_9
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "leadScreeningTrue",
            name: "hasLeadScreening",
            class: "form-check-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.leadScreening) = $event)),
            value: true
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, _ctx.patientHealthHistory.pediatricHistory.leadScreening]
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "leadScreeningFalse",
            name: "hasLeadScreening",
            class: "form-check-input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.leadScreening) = $event)),
            value: false
          }, null, 512 /* NEED_PATCH */), [
            [_vModelRadio, _ctx.patientHealthHistory.pediatricHistory.leadScreening]
          ]),
          _hoisted_15
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.otherPediatricScreening) = $event)),
          id: "pediatric-other"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.patientHealthHistory.pediatricHistory.otherPediatricScreening]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "newborn-history-na",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.newBornHistory) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, _ctx.patientHealthHistory.pediatricHistory.newBornHistory]
            ]),
            _hoisted_23
          ]),
          (!_ctx.patientHealthHistory.pediatricHistory.newBornHistory)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.gestationalAgeAtBirth) = $event)),
                    id: "gestational-age",
                    placeholder: "Weeks"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.patientHealthHistory.pediatricHistory.gestationalAgeAtBirth]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_EnumTypeaheadInput, {
                        "enum-list": _ctx.lengthScaleEnum,
                        "prefill-value": _ctx.patientHealthHistory.pediatricHistory.lengthScale,
                        "onUpdate:prefill-value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.lengthScale) = $event)),
                        placeholder: "Select Scale"
                      }, null, 8 /* PROPS */, ["enum-list", "prefill-value"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.lengthAtBirth) = $event)),
                        placeholder: `${_ctx.isLengthImperial ? 'in.' : 'cm.'}`,
                        maxlength: "5",
                        "number-only": "decimal"
                      }, null, 8 /* PROPS */, _hoisted_33), [
                        [_vModelText, _ctx.patientHealthHistory.pediatricHistory.lengthAtBirth]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fontanelsEnum, (value, key) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: `fontanel-${value.name}`,
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.fontanels) = $event)),
                          value: value.value
                        }, null, 8 /* PROPS */, _hoisted_38), [
                          [_vModelCheckbox, _ctx.patientHealthHistory.pediatricHistory.fontanels]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `fontanel-${value.name}`
                        }, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(value.name), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_39)
                      ]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.umbilicusEnum, (value, key) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: `umbilicus-${value.name}`,
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.umbilicus) = $event)),
                          value: value.value
                        }, null, 8 /* PROPS */, _hoisted_45), [
                          [_vModelCheckbox, _ctx.patientHealthHistory.pediatricHistory.umbilicus]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `umbilicus-${value.name}`
                        }, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(value.name), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_46)
                      ]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        (!_ctx.patientHealthHistory.pediatricHistory.newBornHistory)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.newBornScreeningResult) = $event)),
                  id: "newborn-screening-results"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.patientHealthHistory.pediatricHistory.newBornScreeningResult]
                ])
              ]),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(_component_EnumTypeaheadInput, {
                    "enum-list": _ctx.weightScaleEnum,
                    "prefill-value": _ctx.patientHealthHistory.pediatricHistory.birthWeightScale,
                    "onUpdate:prefill-value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.birthWeightScale) = $event)),
                    placeholder: "Select Scale"
                  }, null, 8 /* PROPS */, ["enum-list", "prefill-value"])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, " Birth Weight " + _toDisplayString(_ctx.isWeightImperial ? "lb." : "kg."), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.birthWeightLarge) = $event)),
                    id: "birth-weight-lb",
                    placeholder: `${_ctx.isWeightImperial ? 'lb.' : 'kg.'}`,
                    maxlength: "5"
                  }, null, 8 /* PROPS */, _hoisted_57), [
                    [_vModelText, _ctx.birthWeightLarge],
                    [_directive_number_only]
                  ]),
                  (_ctx.isWeightImperial)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                        _hoisted_59,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.birthWeightSmall) = $event)),
                          id: "birth-weight-oz",
                          placeholder: "oz.",
                          maxlength: "5"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, _ctx.birthWeightSmall],
                          [_directive_number_only]
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode(_component_EnumTypeaheadInput, {
                      "enum-list": _ctx.lengthScaleEnum,
                      "prefill-value": _ctx.patientHealthHistory.pediatricHistory.headCircumferenceScale,
                      "onUpdate:prefill-value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.headCircumferenceScale) = $event)),
                      placeholder: "Select Scale"
                    }, null, 8 /* PROPS */, ["enum-list", "prefill-value"])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.patientHealthHistory.pediatricHistory.headCircumference) = $event)),
                      placeholder: "${isCircumferenceImperial ? 'in.' : 'cm.'}",
                      maxlength: "5",
                      "number-only": "decimal"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.patientHealthHistory.pediatricHistory.headCircumference]
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}